// 登录退出
const loginIn = 'loginIn'
const logout = 'logout'

// 用户
const userList = 'user/list'
const userCreate = 'user/create'
const userView = 'user/view'
const userAdd = 'user/add'
const userUpdate = 'user/update'
const userDelete = 'user/delete'
const userResetPwd = 'user/resetPwd'
const userUpdatePwd = 'user/updatePwd'
const userSetStatus = 'user/setStatus'
const userBindCoach = 'user/bindCoach'
const userUnbindCoach = 'user/unbindCoach'

// 场馆配置
const venueConfigGet = 'venueConfig/get'
const venueConfigUpdate = 'venueConfig/update'

// 菜单
const menuList = 'menu/list'
const menuCreate = 'menu/create'
const menuAdd = 'menu/add'
const menuUpdate = 'menu/update'
const menuDelete = 'menu/delete'
const menuSetStatus = 'menu/setStatus'

// 角色
const roleList = 'role/list'
const roleAdd = 'role/add'
const roleUpdate = 'role/update'
const roleDelete = 'role/delete'

// 用户组
const userGroupList = 'userGroup/list'
const userGroupAdd = 'userGroup/add'
const userGroupUpdate = 'userGroup/update'
const userGroupDelete = 'userGroup/delete'

// 权限
const divideUser = 'relation/divideUser'
const divideRole = 'relation/divideRole'
const divideMenu = 'relation/divideMenu'
const relationListUsers = 'relation/listUsers'
const relationListRoles = 'relation/listRoles'
const relationListMenus = 'relation/listMenus'

// 上传文件
const attachUpload = 'attach/upload'
const attachRemove = 'attach/remove'
const attachDownload = 'attach/download'
const attachDownloadMyFile = 'attach/downloadMyFile'

// 下拉选
const rechargeArray = 'apiSelect/rechargeArray'
const projectArray = 'apiSelect/projectArray'
const timeSlotArray = 'apiSelect/timeSlotArray'

const getBookingManageSelect = 'apiSelect/getBookingManageSelect'

// 会员
const memberList = 'member/list'
const memberSearch = 'member/search'
const memberSearchForBind = 'member/searchForBind'
const memberAdd = 'member/add'
const memberUpdate = 'member/update'
const memberDelete = 'member/delete'
const memberRecharge = 'member/recharge'
const memberRefund = 'member/refund'
const memberTransList = 'member/transList'
const memberSetStatus = 'member/setStatus'

// 储值档位配置
const rechargeConfigList = 'rechargeConfig/list'
const rechargeConfigAdd = 'rechargeConfig/add'
const rechargeConfigUpdate = 'rechargeConfig/update'
const rechargeConfigDelete = 'rechargeConfig/delete'
const rechargeConfigSetStatus = 'rechargeConfig/setStatus'

// 服务项目配置
const projectList = 'project/list'
const projectAdd = 'project/add'
const projectUpdate = 'project/update'
const projectDelete = 'project/delete'
const projectSetStatus = 'project/setStatus'
const projectSetShowStatus = 'project/setShowStatus'

// 预约时段配置
const timeSlotList = 'timeSlot/list'
const timeSlotAdd = 'timeSlot/add'
const timeSlotUpdate = 'timeSlot/update'
const timeSlotDelete = 'timeSlot/delete'
const timeSlotSetStatus = 'timeSlot/setStatus'

// 预约订单管理
const bookingList = 'booking/list'
const bookingAdd = 'booking/add'
const bookingCancel = 'booking/cancel'
const bookingCheckIn = 'booking/checkIn'
const bookingNoShow = 'booking/noShow'
const bookingDelete = 'booking/delete'

//统计
const dashboardData = 'statistics/dashboardData'

export default {
    loginIn,
    logout,
    // 用户
    userList,
    userCreate,
    userView,
    userAdd,
    userUpdate,
    userDelete,
    userResetPwd,
    userUpdatePwd,
    userSetStatus,
    userBindCoach,
    userUnbindCoach,
    // 场馆配置
    venueConfigGet,
    venueConfigUpdate,
    // 菜单
    menuList,
    menuCreate,
    menuAdd,
    menuUpdate,
    menuDelete,
    menuSetStatus,
    // 角色
    roleList,
    roleAdd,
    roleUpdate,
    roleDelete,
    // 用户组
    userGroupList,
    userGroupAdd,
    userGroupUpdate,
    userGroupDelete,
    // 权限
    divideUser,
    divideRole,
    divideMenu,
    relationListUsers,
    relationListRoles,
    relationListMenus,
    // 上传文件
    attachUpload,
    attachRemove,
    attachDownload,
    attachDownloadMyFile,
    //下拉选
    rechargeArray,
    projectArray,
    timeSlotArray,

    getBookingManageSelect,
    // 会员
    memberList,
    memberSearch,
    memberSearchForBind,
    memberAdd,
    memberUpdate,
    memberDelete,
    memberRecharge,
    memberRefund,
    memberTransList,
    memberSetStatus,
    // 储值档位配置
    rechargeConfigList,
    rechargeConfigAdd,
    rechargeConfigUpdate,
    rechargeConfigDelete,
    rechargeConfigSetStatus,
    // 服务项目配置
    projectList,
    projectAdd,
    projectUpdate,
    projectDelete,
    projectSetStatus,
    projectSetShowStatus,
    // 预约时段配置
    timeSlotList,
    timeSlotAdd,
    timeSlotUpdate,
    timeSlotDelete,
    timeSlotSetStatus,
    // 预约订单管理
    bookingList,
    bookingAdd,
    bookingCancel,
    bookingCheckIn,
    bookingNoShow,
    bookingDelete,
    // 统计
    dashboardData
}
